import { useContext, createContext } from "react"

export type StepperContextValue = {
  headingId: string
}

export const StepperContext = createContext<StepperContextValue | null>(null)

export function useStepperContext(): StepperContextValue {
  const context = useContext(StepperContext)

  if (!context)
    throw new Error("useStepperContext must be used within a Stepper")

  return context
}
